// Helper per convertire camelCase in snake_case e garantire valori di default
export function toBackendPayload(flow: Partial<WhitelistFlowForm>) {
  return {
    title: flow.title || '',
    rules: flow.rules || '',
    required_questions: Math.max(1, Number(flow.requiredQuestions) || 3),
    pass_score: Number(flow.passScore) || 60,
    whitelist_role_id: flow.whitelistRoleId || null,
    staff_notification_channel: flow.staffNotificationChannel || null,
    publish_channel_id: flow.publishChannelId || null,
    max_attempts_per_question: Number(flow.maxAttemptsPerQuestion) || 3,
    require_code_verification: flow.requireCodeVerification ?? true,
    enabled: flow.enabled ?? true,
  };
}
import { api } from './api';

export interface WhitelistFlowForm {
  id: string;
  title: string;
  rules: string;
  requiredQuestions: number;
  passScore: number;
  whitelistRoleId: string;
  staffNotificationChannel: string;
  publishChannelId: string;
  maxAttemptsPerQuestion: number;
  requireCodeVerification: boolean;
  enabled: boolean;
}

export const aiInterviewApi = {
  spawnRulesEmbed: (serverId: string, flowId?: string) =>
    api.post(`/api/servers/${serverId}/ai-interview/spawn-rules`, { flowId }),
  getRulesEmbedStatus: (serverId: string, flowId?: string) =>
    api.get<{
      configured: boolean;
      rulesChannelId: string | null;
      spawned: boolean;
      messageId: string | null;
      messageUrl: string | null;
    }>(`/api/servers/${serverId}/ai-interview/rules-status${flowId ? `?flowId=${encodeURIComponent(flowId)}` : ''}`),
  testWhitelistFlow: (serverId: string, flowId: string, userId: string) =>
    api.post(`/api/servers/${serverId}/ai-interview/test-flow`, { flowId, userId }),
  // CRUD RESTful per i flow
  getFlows: (serverId: string): Promise<WhitelistFlowForm[]> =>
    api.get(`/api/servers/${serverId}/ai-interview/flows`),
  createFlow: (serverId: string, data: any): Promise<WhitelistFlowForm> =>
    api.post(`/api/servers/${serverId}/ai-interview/flows`, data),
  updateFlow: (serverId: string, flowId: string, data: any): Promise<WhitelistFlowForm> =>
    api.put(`/api/servers/${serverId}/ai-interview/flows/${flowId}`, data),
  deleteFlow: (serverId: string, flowId: string): Promise<void> =>
    api.delete(`/api/servers/${serverId}/ai-interview/flows/${flowId}`),
};
